<template lang="pug">
  #LabelIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 喜好列表
    .container-width
      .p-3
        .mb-3
          h5.mb-3(
            style="color: #6c757d;"
          ) 品牌建立
          div(
            v-for="(tagType,key) in backendTags",
            :key="tagType.id",
          )
            label.ml-1.red(v-if='key') {{ key }}
            b-card.border-0.mb-2.customerCard.word-break-all(
              no-body
              bg-variant="white",
              v-for="(tag, index) in tagType",
              @click="editHandler(tag, 'backend')"
            )
              .row.p-2
                .col-10.d-flex.align-items-center
                  span.mr-3.font-weight-bold {{ tag.tag_name }}
                  i.fas.fa-user.mr-1.text-danger
                  span.text-danger {{ tag.use_count }}
                .col-2.d-flex.align-items-center.justify-content-end
                  b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.btn-custom(
                    variant="remind",
                    @click.stop.prevent="pushHandler(tag,'backend')",
                    style="border: 0.4rem solid #fff;border-radius: 50px;padding: 10px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
                  )
                    i.custom.fas.fa-volume-up.icon-icon_megaphone(style="width:16px")
          p.mb-0(
            v-if="tags.length === 0"
          ) 無喜好資料
        .mb-3
          h5.mb-3(
            style="color: #6c757d;"
          ) 美容顧問建立
          b-card.border-0.mb-2.customerCard.word-break-all(
            no-body
            bg-variant="white",
            v-for="(tag,index) in tags",
            :key="tag.id",
            @click="editHandler(tag, 'ba')"
            v-if="tags"
          )
            .row.p-2
              .col-10.d-flex.align-items-center
                span.mr-3.font-weight-bold {{ tag.tag_name }}
                i.fas.fa-user.mr-1.text-danger
                span.text-danger {{ tag.use_count }}
              .col-2.d-flex.align-items-center.justify-content-end
                b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.mr-2.btn-custom(
                  variant="remind",
                  @click.stop.prevent="deleteHandler(tag)",
                  v-if="nowSelect === 'ba'",
                  style="border: 0.4rem solid #fff;border-radius: 50px;padding: 10px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
                )
                  i.custom.iconDelete(style="width:16px")

                b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.btn-custom(
                  variant="remind",
                  @click.stop.prevent="pushHandler(tag,'ba')",
                  style="border: 0.4rem solid #fff;border-radius: 50px;padding: 10px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
                )
                  i.custom.icon-icon_megaphone(style="width:16px")
          p.mb-0(
            v-if="backendTags.length === 0"
          ) 無美容顧問建立資料
        .text-center
          b-button(
            variant="remind",
            class="mb-3 font-weight-bold",
            v-if="nowSelect === 'ba'",
            @click="createLabelFormShowHandler()",
            style="border: 0.3rem solid #000;border-radius: 9487px;padding: 5px 20px;box-shadow: 0.2rem 0.2rem 0 #00000033;"
          ) ＋新增喜好

    b-modal#create-label-modal(
      title="請填寫顧客喜好",
      centered,
      scrollable,
      hide-header,
      hide-footer,
      v-model="createLabelModalShow"
    )
      .row
        .col-10
          h5.mb-3 新增顧客喜好
        .col-2.d-flex.align-items-center.justify-content-center
          i.custom.iconClose(
            @click="createLabelFormCloseHandler()"
          )
      label(style="color: #6c757d;") 喜好名稱
      b-form-input.mb-3.border-black.border-width-lg(
        id="name",
        type="text",
        required,
        trim,
        v-model="labelCreateForm.name",
        placeholder="請輸入欲新增的顧客喜好名稱"
      )
      .row.justify-content-center
        b-button.col-6(
          variant="remind",
          class="mb-3 font-weight-bold",
          v-if="nowSelect === 'ba'",
          @click="createLabelHandler()",
          style="border: 0.3rem solid #000;border-radius: 9487px;padding: 5px 20px;box-shadow: 0.15rem 0.15rem 0 #00000033;"
        ) 送出
</template>

<script>
import { mapState } from 'vuex';
import defaultPhotoStickerUrl from '@/assets/images/default/defaultImg404.png';
import { SA_LABEL_EDIT, SA_LABEL_SHOW } from '@/router/sa/label';
import { SA_GROUP_PUSH_INDEX } from '@/router/sa/group-push';

export default {
  name: 'LabelIndex',
  data() {
    return {
      defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`,
      nowSelect: 'ba',
      toolsOpen: [],
      createLabelModalShow: false,
      labelCreateForm: {
        name: ''
      }
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.getTagsHandler();
  },
  methods: {
    // 取得前台標籤
    getTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '喜好列表載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得標籤
      vm.$store.dispatch('sa_label/getTagsHandler')
        .then(() => {
          // 取得標籤
          vm.$store.dispatch('sa_label/getBackendTagsHandler')
            .then(() => {
              vm.$swal.close();
            });
        });
    },
    toolsHandler(index) {
      const vm = this;
      if (vm.toolsOpen.indexOf(index) === -1) {
        vm.toolsOpen.push(index);
      } else {
        vm.toolsOpen.splice(vm.toolsOpen.indexOf(index), 1);
      }
    },
    pushHandler(tag, type) {
      const vm = this;
      if (!tag.use_count || tag.use_count === 0) return;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      let apiTarget;

      switch (type) {
        case 'ba':
          apiTarget = 'showTagHandler';
          break;
        case 'backend':
          apiTarget = 'showBackendTagHandler';
          break;
        default:
          break;
      }

      if (!vm.nowSelect || !apiTarget) {
        vm.$swal.fire({
          icon: 'error',
          title: '推播目標錯誤[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store.dispatch(`sa_label/${apiTarget}`, {
        tag_id: tag.tag_id
      })
        .then((res) => {
          vm.$swal.close();
          vm.$store.commit('sa_group_push/setMemberList', res.has_tag_members);
          vm.$router.push({
            name: SA_GROUP_PUSH_INDEX
          });
        });
    },
    editHandler(tag, mode) {
      const vm = this;
      vm.$router.push({
        name: SA_LABEL_EDIT,
        params: {
          tag_id: tag.tag_id,
          mode
        }
      });
    },
    deleteHandler(tag) {
      const vm = this;
      vm.$swal.fire({
        title: '您確定刪除顧客喜好?',
        text: '刪除後無法復原！',
        html: `請注意，刪除後顧客將失去<span style="color: #d33"> ${tag.tag_name} </span> 顧客喜好`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'custom-swal-btn',
          cancelButton: 'custom-swal-btn'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '顧客喜好刪除中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          vm.$store.dispatch('sa_label/destroyTagHandler', {
            tag_id: tag.tag_id
          })
            .then(() => {
              vm.$swal.close();
              vm.$store.commit('sa_label/resetAll');
              vm.getTagsHandler();
            });
        }
      });
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'ba':
          if (vm.nowSelect === 'ba') return;
          vm.nowSelect = 'ba';
          vm.$store.commit('sa_label/resetAll');
          vm.getTagsHandler();
          break;
        case 'backend':
          if (vm.nowSelect === 'backend') return;
          vm.nowSelect = 'backend';
          vm.$store.commit('sa_label/resetAll');
          vm.getBackendTagsHandler();
          break;
        default:
          break;
      }
    },
    createLabelFormShowHandler() {
      const vm = this;
      vm.createLabelModalShow = true;
    },
    createLabelFormCloseHandler() {
      const vm = this;
      vm.createLabelModalShow = false;
    },
    createLabelHandler() {
      const vm = this;
      vm.$store.dispatch('sa_label/storeTagHandler', {
        tag_name: vm.labelCreateForm.name,
      })
        .then(() => {
          vm.getTagsHandler();
          vm.createLabelModalShow = false;
          vm.labelCreateForm.name = '';
          vm.$swal.close();
        });
    }
  },
  computed: {
    ...mapState({
      tags: (state) => state.sa_label.tags,
      backendTags: (state) => state.sa_label.backendTags
    })
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0.2rem solid #000!important;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}

@font-face {
 font-family: "icon";
 src: url("../../../assets/fonts/icon.eot?hrpp7d");
 src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
 font-weight: normal;
 font-style: normal;
 font-display: block;
}

i.custom {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-icon_megaphone:before {
 content: "\e912";
}

.iconDelete:before {
 content: "\e908";
}

input[type="text"], input[type="date"], select, textarea {
  border: 0;
  outline: 0;
  background-color: #eee;
  font-size: 1.2rem;
  padding: 0.8rem 1.2rem;
  border-radius: 9487px;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.iconClose:before {
  content: "\e908";
}
.red{
  color: #d41313;
}
</style>
<style>
  .modal-content {
    border-radius: 10px;
  }
</style>
